var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.538 8.56195C14.538 12.3004 11.5074 15.3309 7.76898 15.3309C4.03058 15.3309 1 12.3004 1 8.56195C1 4.82355 4.03058 1.79297 7.76898 1.79297C11.5074 1.79297 14.538 4.82355 14.538 8.56195ZM15.538 8.56195C15.538 12.8526 12.0597 16.3309 7.76898 16.3309C3.47829 16.3309 0 12.8526 0 8.56195C0 4.27126 3.47829 0.792969 7.76898 0.792969C12.0597 0.792969 15.538 4.27126 15.538 8.56195ZM8.04515 9.78809H7.0344L7.02952 9.39746C7.01487 8.7334 7.30296 8.29395 7.9719 7.89355C8.56272 7.53711 8.77268 7.25391 8.77268 6.75586V6.75098C8.77268 6.19434 8.33323 5.79395 7.66917 5.79395C6.99534 5.79395 6.57542 6.2041 6.52171 6.7998L6.51683 6.84375H5.50608L5.51097 6.78516C5.57444 5.73535 6.30686 4.89551 7.72288 4.89551C9.00706 4.89551 9.88108 5.65723 9.88108 6.70703V6.71191C9.88108 7.46387 9.50022 7.99609 8.85569 8.38184C8.22581 8.75293 8.04515 9.0166 8.04515 9.50977V9.78809ZM8.19163 11.4189C8.19163 11.7754 7.91331 12.0537 7.5471 12.0537C7.19065 12.0537 6.90745 11.7754 6.90745 11.4189C6.90745 11.0625 7.19065 10.7891 7.5471 10.7891C7.91331 10.7891 8.19163 11.0625 8.19163 11.4189Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.7ec37dae.svg";
export { ForwardRef as ReactComponent };